// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";

import { TransitionGroup } from "react-transition-group";

import { Icon, Popup } from "semantic-ui-react";

import "./ApplicationMenuAction.less";

import { ApplicationMenuActionItem } from "./ApplicationMenuActionItem";

import { ApplicationFrameContext } from "../ApplicationFrame";
import { getApplicationClassName, getClassName } from "../utils/className";

const className = getApplicationClassName("menu", "action");

export type ApplicationMenuActionProps = {
	actions: (
		| {
				identifiant: string | number;
				icon: string;
				title: string;
				onClick: () => void;
		  }
		| React.ReactElement
	)[];
};

export type ApplicationMenuActionType =
	React.ComponentType<ApplicationMenuActionProps>;

export const ApplicationMenuAction: ApplicationMenuActionType = (
	props: ApplicationMenuActionProps,
) => {
	const { actions } = props;

	const [open, setOpen] = React.useState(false);

	const { menu } = React.useContext(ApplicationFrameContext);

	const handleOpen = React.useCallback(() => {
		React.startTransition(() => {
			setOpen(true);
		});
	}, []);

	const handleClose = React.useCallback(() => {
		React.startTransition(() => {
			setOpen(false);
		});
	}, []);

	return (
		!_.isEmpty(actions) && (
			<Popup
				on="hover"
				onOpen={handleOpen}
				onClose={handleClose}
				open={open}
				trigger={
					<div className={getClassName(className, "item", { open })}>
						<Icon name="add circle" size="large" circular />
					</div>
				}
				position="right center"
				hoverable
				hideOnScroll
				basic
				offset={[0, menu.open ? -295 : 0]}
				style={{
					background: "transparent",
					border: "none",
					boxShadow: "none",
				}}
			>
				<TransitionGroup className="ui list large horizontal">
					{_.map(actions, (item, index) =>
						React.isValidElement<{ open: boolean; delay: number }>(item) ? (
							// eslint-disable-next-line max-len
							React.cloneElement(item, {
								open,
								delay: 60 * (open ? index : actions.length - index),
							})
						) : (
							<ApplicationMenuActionItem
								open={open}
								delay={60 * (open ? index : actions.length - index)}
								key={item.identifiant}
								identifiant={item.identifiant}
								icon={item.icon}
								title={item.title}
								onClick={item.onClick}
							/>
						),
					)}
				</TransitionGroup>
			</Popup>
		)
	);
};
